import React, { useState } from 'react';

import { ExtendedInput, Popover } from '@geneui/components';
import DatePicker from '@geneui/components/DatePicker';

import styles from './monthPickerInput.module.scss';

const MonthPickerInput = ({ onChange, ...restProps }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { onBlur: omit, onChange: omit1, onFocus: omit2, value, ...inputProps } = restProps;

  const handleChange = newRange => {
    const startValue = newRange[0];

    onChange(startValue);
    setIsOpen(false);
  };

  return (
    <Popover
      isOpen={isOpen}
      toggleHandler={() => setIsOpen(prev => !prev)}
      Content={
        <div className={styles.monthPickerInputWrapper}>
          <DatePicker.MonthPicker rangeStartDefault={value} {...restProps} onChange={handleChange} />
        </div>
      }
    >
      <ExtendedInput value={value} itemsDirection="end" icon="bc-icon-calendar" {...inputProps} />
    </Popover>
  );
};

export default MonthPickerInput;
